import PublicMainFooter from "components/footers/PublicMainFooter";
import PublicMainNav from "components/navigations/PublicMainNav";
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAppContext from "state/AppContext";

export default function UnauthenticatedUserFilter() {
  const appContext = useAppContext();
  const { account } = appContext;
  const { isAuthenticated } = account;
  const location = useLocation();

  return !isAuthenticated ? (
    <div>
      <PublicMainNav />
      <Outlet />
      <PublicMainFooter />
    </div>
  ) : (
    <Navigate to="/" state={{ from: location }} />
  );
}
